var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"big-m-t big-m-b",attrs:{"id":"my-music"}},[_c('div',{staticClass:"d-f fd-c ai-c p-hor"},[_c('SongsPlaylistProfile',{attrs:{"playlist-position":0,"playlist":_vm.uploadsList,"is-own-profile":true,"edit-buttons":true},on:{"play-select-song":_vm.playSelectedSongAsync}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }